// removed by extract-text-webpack-plugin
module.exports = {"button":"_1Dbzt","icon":"_18TCf","facebook":"_3gl0x","twitter":"_2G9lv","gPlus":"rhdNG","link":"fx736"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-share-button/post-share-button.scss
// module id = 1712
// module chunks = 0